<script>
  import { fade } from 'svelte/transition'
  import { cubicOut } from 'svelte/easing'
	import { hero_expanded, dark_theme} from './../stores.js'
  
  const images = ['a', 'd', 'k', 'm', 'o', 'w']
  const rand = Math.floor(Math.random()*images.length)
  const rand_image = images[rand]

</script>

{#if $hero_expanded}
  <div>
    <img 
      transition:fade="{{ duration: 500, easing: cubicOut }}" 
      class:transparent={$dark_theme}
      src={"/assets/illustrations/" + rand_image + ".png"} 
      alt="Illustration of a hand working on a letter"
      >
  </div>
{/if}

<style>
  div {
    position: absolute;
    top: 0rem;
    right: 0rem;
    width: 50%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
  }
  img {
    width: 100%;
    mask-image: linear-gradient(90deg, transparent, 2%, black);
    -webkit-mask-image: linear-gradient(90deg, transparent, 2%, black);
  }
  img.transparent {
    opacity: 0.8;
  }

  @media only screen and (max-width: 880px) {
		div {
			width: 100%;
		}
    img {
      mask-image: linear-gradient(0deg, transparent, 60%, black);
      -webkit-mask-image: linear-gradient(0deg, transparent, 60%, black);
    }
  }
</style>